/**
 * Determines if the supplied URL hosts a supported video type
 **/
const isVideo = url => /\.(mp4|m4v|mov)$/i.test(url);

export default isVideo;
